import { useCallback, useEffect, useRef } from 'react';

type UseConcurrentFetchProtectionProps = {
  isLoading: boolean;
  onFetch: () => void;
};

export const useConcurrentFetchProtection = ({ isLoading, onFetch }: UseConcurrentFetchProtectionProps) => {
  const fetchInProgress = useRef(false);
  const pendingFetch = useRef(false);

  useEffect(() => {
    fetchInProgress.current = isLoading;

    if (!isLoading && pendingFetch.current) {
      pendingFetch.current = false;
      onFetch();
    }
  }, [isLoading, onFetch]);

  const safeFetch = useCallback(() => {
    if (fetchInProgress.current) {
      pendingFetch.current = true;
      return;
    }

    fetchInProgress.current = true;
    onFetch();
  }, [onFetch]);

  return safeFetch;
};
